/**
 * Footer Component
 *
 * Application footer with tagline and documentation link.
 * Extracted from App.tsx for better separation of concerns.
 */

import { memo } from 'react';
import { Video } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

function navigateTo(path: string) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export const Footer = memo(function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="app-footer">
      <div className="flex flex-col md:flex-row justify-between items-center gap-3">
        <div className="flex items-center space-x-2">
          <Video className="h-5 w-5 text-white/50" />
          <span className="text-white/50">{t('app.footer.tagline')}</span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-white/40">
          <a
            href="/privacy"
            onClick={(e) => {
              e.preventDefault();
              navigateTo('/privacy');
            }}
            className="hover:text-white/70 transition-colors min-h-[32px] flex items-center"
          >
            {t('app.footer.privacy')}
          </a>
          <a
            href="/terms"
            onClick={(e) => {
              e.preventDefault();
              navigateTo('/terms');
            }}
            className="hover:text-white/70 transition-colors min-h-[32px] flex items-center"
          >
            {t('app.footer.terms')}
          </a>
          <span>·</span>
          <span>v{__APP_VERSION__}</span>
        </div>
      </div>
    </footer>
  );
});
